import {CalculatorBase} from "./CalculatorBase";
import {NumericUtilities} from "../../Utilities/NumericUtilities";
import {
    FBFieldWithPriceBase,
    FBFieldWithPriceBaseProps,
    FBFieldWithPriceBaseState
} from "../../Fields/Core/FBFieldWithPriceBase";
import {FBFieldWithPriceBaseModel} from "FormBuilder/Fields/Core/FBFieldWithPriceBase.Model";

export class PercentageOriginalPriceAndOptionsCalculator extends CalculatorBase{
    private SalePercentage:any;
    private RegularPercentage:any;
    constructor(){
        super();
        this.SalePercentage=null;
        this.RegularPercentage=null;
    }

    public SetRegularPercentage(price:any)
    {
        this.RegularPercentage=price;
        return this;
    }

    public SetSalePercentage(price:any)
    {
        this.SalePercentage=price;
        return this;
    }


    IsDynamic(): boolean {
        return true;
    }

    Destroy() {
        this.Field.FormBuilder.PriceManager.FieldPriceUpdated.Unsubscribe(this);
    }


    Initialize(Field: FBFieldWithPriceBaseModel) {
        super.Initialize(Field);
        this.Field.FormBuilder.PriceManager.FieldPriceUpdated.Subscribe(this,x=>this.ExecuteAndUpdate());
        Field.FormBuilder.ProductPriceChanged.Subscribe(this,()=>this.ExecuteAndUpdate());
        return this;
    }

    public GetDependsOnOtherFields(){
        return true;
    }



    public ExecuteCalculation(value:any):{RegularPrice:any,SalePrice:any,Quantity:number}   {
        if(value==null)
            value=this.Field.GetValue();
        if(value.length>0) {
            let productPriceToUse = this.Field.FormBuilder.GetProductPrice().toString();
            let productSalePrice = this.Field.FormBuilder.GetSalePrice().toString();


            if(productSalePrice!='')
                productPriceToUse=productSalePrice;
            productPriceToUse=NumericUtilities.ParseNumber(productPriceToUse);
            productPriceToUse+=this.Field.FormBuilder.PriceManager.GetPriceIgnoringFields([this.Field]);



            let salePercentage =this.SalePercentage==null?this.Field.GetSalePrice():this.SalePercentage;
            let regularPercentage:any=this.RegularPercentage==null?this.Field.GetRegularPrice():this.RegularPercentage;


            let regularPrice:any='';
            let salePrice:any='';

            if(salePercentage!='')
            {
                let percentage=NumericUtilities.ParseNumber(salePercentage);
                if(percentage>0)
                    percentage=percentage/100;
                salePrice=NumericUtilities.ParseNumber(productPriceToUse)*percentage;
            }

            if(regularPercentage!='')
            {
                let percentage=NumericUtilities.ParseNumber(regularPercentage);
                if(percentage>0)
                    percentage=percentage/100;
                regularPrice=NumericUtilities.ParseNumber(productPriceToUse)*percentage;
            }


            if(value.length>0) {
                if(salePrice!='')
                    return {Quantity:this.GetQuantityInput(),RegularPrice:regularPrice,SalePrice:salePrice};
                else
                    return {Quantity:this.GetQuantityInput(),RegularPrice: regularPrice,SalePrice:''};
            }

        }else
            return {RegularPrice:'',SalePrice:'',Quantity:0};

    }



    public ParseNumber(number:any)
    {
        let num=parseFloat(number);
        if(isNaN(num))
            return 0;
        return num;
    }

}